import type { TFunction } from "i18next";
import type { TourStep } from "../TourProvider";
import { queryTourTarget } from "../utils/queryTourTarget";

/**
 * Tour configuration for the Property Table Page (/property)
 *
 * Curated refresher:
 * 1. Portfolio list
 * 2. Add Property
 * 3. Sort / find via column headers
 * 4. Open a row → property details
 */
export const propertyTableTour = (t: TFunction): TourStep[] => [
  {
    title: t("Tour_PropertyTable_Welcome_Title"),
    description: t("Tour_PropertyTable_Welcome_Description"),
    target: () => queryTourTarget("property-table-section"),
    placement: "bottom",
  },
  {
    title: t("Tour_PropertyTable_AddButton_Title"),
    description: t("Tour_PropertyTable_AddButton_Description"),
    target: () => queryTourTarget("add-property-button"),
    placement: "left",
  },
  {
    title: t("Tour_PropertyTable_Sort_Title"),
    description: t("Tour_PropertyTable_Sort_Description"),
    target: () => queryTourTarget("property-table-columns"),
    placement: "top",
  },
  {
    title: t("Tour_PropertyTable_OpenRow_Title"),
    description: t("Tour_PropertyTable_OpenRow_Description"),
    target: () => queryTourTarget("property-table-rows"),
    placement: "top",
  },
];
